import {
  createValidation,
  validatorRequired,
} from '../../utils/formValidators';
import { seller } from '../../constants/parameters';

export default createValidation([
  {
    name: seller.NAME,
    validators: (field) => validatorRequired()(field),
  },
  {
    name: seller.SOLD,
    validators: (field) => validatorRequired()(field),
  },
  {
    name: seller.CODE,
    validators: (field) => validatorRequired()(field),
  },
]);
